import { FormInstance } from "antd/es/form";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHomePage_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePage_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Get_Date: any[];
  Get_Date_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Yonetim_FirmaByFirmaNo: any[];
  Get_Yonetim_FirmaByFirmaNo_dummy: any[];
  Get_Home_Summary_FTL_Bekleyen: any[];
  Get_Home_Summary_FTL_Bekleyen_dummy: any[];
  Get_Home_Summary_LTL_Bekleyen: any[];
  Get_Home_Summary_LTL_Bekleyen_dummy: any[];
  Get_Home_Summary_FTL_Tamamlanan: any[];
  Get_Home_Summary_FTL_Tamamlanan_dummy: any[];
  Get_Home_Summary_LTL_Tamamlanan: any[];
  Get_Home_Summary_LTL_Tamamlanan_dummy: any[];
  Rprv2_YukVeren_DashboardOzet: any[];
  Rprv2_YukVeren_DashboardOzet_dummy: any[];
  Sms_Get_Credits: string;
  Sms_Get_Credits_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Tanim_TedarikciListe: any[];
  Get_Tanim_TedarikciListe_dummy: any[];
  Rprv2_TedarikciPerformans_Dashboard: any[];
  Rprv2_TedarikciPerformans_Dashboard_dummy: any[];
  Rprv2_YuklemePerformans_Dashboard: any[];
  Rprv2_YuklemePerformans_Dashboard_dummy: any[];
  isComp609258Visible: "visible" | "hidden";
  isComp200514Visible: "visible" | "hidden";
  isComp226317Visible: "visible" | "hidden";
  isComp996995Visible: "visible" | "hidden";
  isComp426910Visible: "visible" | "hidden";
  isComp535107Visible: "visible" | "hidden";
  isComp420656Visible: "visible" | "hidden";
  isComp226719Visible: "visible" | "hidden";
  isComp744468Visible: "visible" | "hidden";
  isComp664151Visible: "visible" | "hidden";
  isComphomepage_579538AuthorizationVisible: "visible" | "hidden";
  isComphomepage_887495AuthorizationVisible: "visible" | "hidden";
  isComphomepage_226719AuthorizationVisible: "visible" | "hidden";
  isComphomepage_664151AuthorizationVisible: "visible" | "hidden";
}

export class HomePage_ScreenBase extends React.PureComponent<
  IHomePage_ScreenProps,
  any
> {
  homepage_201614_value_kuikaDateRef: React.RefObject<any>;
  homepage_419747_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "5ef2bcc9-3898-4404-80c9-f72df4111c93",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 740733,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        { Id: 692118, PropertyName: "value", Value: "Merhaba," },
        { Id: 900581, PropertyName: "value", Value: "Lisans Tipi :" },
        { Id: 790812, PropertyName: "value", Value: "Lisans Bitiş Tarihi :" },
        { Id: 789887, PropertyName: "value", Value: "Kalan SMS Kredisi" },
        { Id: 491060, PropertyName: "value", Value: "Bağlı Firma Adı" },
        { Id: 209655, PropertyName: "value", Value: "Full Truck Sevkiyat" },
        {
          Id: 67523,
          PropertyName: "value",
          Value: "Tamamlanan FTL Sevkiyatlar",
        },
        { Id: 550791, PropertyName: "value", Value: "Yıl" },
        { Id: 982081, PropertyName: "placeholder", Value: "Select Year..." },
        { Id: 245914, PropertyName: "value", Value: "Parsiyel Sevkiyat" },
        {
          Id: 715265,
          PropertyName: "value",
          Value: "Tamamlanan LTL Sevkiyatlar",
        },
        { Id: 969831, PropertyName: "value", Value: "Yıl" },
        { Id: 271474, PropertyName: "placeholder", Value: "Select Year..." },
        { Id: 521930, PropertyName: "value", Value: "Yıl" },
        { Id: 542354, PropertyName: "placeholder", Value: "Select Year..." },
        { Id: 799752, PropertyName: "value", Value: "Ay" },
        { Id: 739949, PropertyName: "placeholder", Value: "Select Month..." },
        { Id: 844251, PropertyName: "value", Value: "Gün" },
        { Id: 201614, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 87210, PropertyName: "value", Value: "Tedarikçi" },
        { Id: 419747, PropertyName: "placeholder", Value: "Tedarikçi Seçiniz" },
        {
          Id: 837434,
          PropertyName: "value",
          Value: "Yükleme Performansı(Sayı)",
        },
        {
          Id: 406973,
          PropertyName: "value",
          Value: "Yükleme Performansı(Oran)",
        },
        {
          Id: 197092,
          PropertyName: "value",
          Value: "Tedarikçi Performansı(Sayı)",
        },
        {
          Id: 84212,
          PropertyName: "value",
          Value: "Tedarikçi Performansı(Oran)",
        },
        { Id: 545738, PropertyName: "value", Value: "Günlük" },
        { Id: 432924, PropertyName: "value", Value: "Aylık" },
        { Id: 738745, PropertyName: "value", Value: "Yıllık" },
        {
          Id: 415971,
          PropertyName: "value",
          Value: "Planlanan Yükleme Sayısı",
        },
        { Id: 510533, PropertyName: "value", Value: "Tedarik Bekleyen Araç" },
        {
          Id: 601053,
          PropertyName: "value",
          Value: "Fabrikaya Ulaşmamış Araç",
        },
        { Id: 116215, PropertyName: "value", Value: "Yükleme Bekleyen Araç" },
        { Id: 310580, PropertyName: "value", Value: "Gerçekleşen Sevkiyat" },
        {
          Id: 393653,
          PropertyName: "value",
          Value: "Planlanan Yükleme Sayısı",
        },
        { Id: 709526, PropertyName: "value", Value: "Tedarik Bekleyen Araç" },
        {
          Id: 616510,
          PropertyName: "value",
          Value: "Fabrikaya Ulaşmamış Araç",
        },
        { Id: 622067, PropertyName: "value", Value: "Yükleme Bekleyen Araç" },
        { Id: 370526, PropertyName: "value", Value: "Gerçekleşen Sevkiyat" },
        {
          Id: 914807,
          PropertyName: "value",
          Value: "Planlanan Yükleme Sayısı",
        },
        { Id: 295932, PropertyName: "value", Value: "Tedarik Bekleyen Araç" },
        {
          Id: 322072,
          PropertyName: "value",
          Value: "Fabrikaya Ulaşmamış Araç",
        },
        { Id: 833311, PropertyName: "value", Value: "Yükleme Bekleyen Araç" },
        { Id: 519016, PropertyName: "value", Value: "Gerçekleşen Sevkiyat" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.homepage_201614_value_kuikaDateRef = React.createRef();
    this.homepage_419747_value_kuikaSelectBoxRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Get_Date: [],
      ReadFromSessionStorage: "",
      Get_Yonetim_FirmaByFirmaNo: [],
      Get_Home_Summary_FTL_Bekleyen: [],
      Get_Home_Summary_LTL_Bekleyen: [],
      Get_Home_Summary_FTL_Tamamlanan: [],
      Get_Home_Summary_LTL_Tamamlanan: [],
      Rprv2_YukVeren_DashboardOzet: [],
      Sms_Get_Credits: "",
      SetValueOf: "",
      Get_Helpers_UserInfoByUserName: [],
      Get_Tanim_TedarikciListe: [],
      Rprv2_TedarikciPerformans_Dashboard: [],
      Rprv2_YuklemePerformans_Dashboard: [],
      dataSource_807538: [
        { key: "0", text: "Yıllık" },
        { key: "1", text: "Aylık" },
        { key: "2", text: "Gunluk" },
      ],
      isComp609258Visible: "hidden",
      isComp200514Visible: "hidden",
      isComp226317Visible: "hidden",
      isComp996995Visible: "hidden",
      isComp426910Visible: "hidden",
      isComp535107Visible: "hidden",
      isComp420656Visible: "hidden",
      isComp226719Visible: "hidden",
      isComp744468Visible: "hidden",
      isComp664151Visible: "hidden",
      isComphomepage_579538AuthorizationVisible: "visible",
      isComphomepage_887495AuthorizationVisible: "visible",
      isComphomepage_226719AuthorizationVisible: "visible",
      isComphomepage_664151AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("homepage", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HomePagePageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_579538AuthorizationVisible",
      [
        "340e8cb3-f976-dd61-e380-0461d10a97c8",
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "ae9cc18c-1277-f9c1-29a1-4976ebb6081e",
        "b4db309c-2564-ed82-7346-5121a6f66ad4",
        "3124c881-afa9-64c4-a413-a7dab050596f",
        "ed21a70d-9ab3-c35f-4b1e-f3a2c658cf91",
        "1126c82c-d16e-9976-54d3-19e6419248c5",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SistemAdmin",
        "SuperUser",
        "Operasyon",
        "OperasyonFTL",
        "OperasyonLTL",
        "DepoLTL",
        "TmsUser",
        "AracGirisCikis",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_887495AuthorizationVisible",
      ["8d6aca26-54fb-d461-9b81-6cbf4daedc32", "Tedarikci"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_226719AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1126c82c-d16e-9976-54d3-19e6419248c5",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "SuperUser",
        "AracGirisCikis",
        "YuklemeFormen",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_664151AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "1126c82c-d16e-9976-54d3-19e6419248c5",
        "SuperUser",
        "AracGirisCikis",
        "YuklemeFormen",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("homepage", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepage", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePagePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      homepage_982081_value: this.state.Get_Date?.at?.(0)?.yil ?? undefined,
      homepage_271474_value: this.state.Get_Date?.at?.(0)?.yil ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePagePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePagePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Date = result?.data.get_Date;
    formVars.homepage_982081_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Date !== undefined
        ? stateVars.Get_Date?.length > 0
          ? stateVars.Get_Date[0].yil
          : null
        : this.state.Get_Date?.length > 0
        ? this.state.Get_Date[0].yil
        : null
    );
    formVars.homepage_271474_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Date !== undefined
        ? stateVars.Get_Date?.length > 0
          ? stateVars.Get_Date[0].yil
          : null
        : this.state.Get_Date?.length > 0
        ? this.state.Get_Date[0].yil
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagePageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        true
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.HomePagePageInit3_,
        "HomePage",
        "Signin",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagePageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePagePageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Yonetim_FirmaByFirmaNo =
      result?.data.get_Yonetim_FirmaByFirmaNo;
    formVars.homepage_141793_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaAdi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaAdi
        : null
    );
    formVars.homepage_291688_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].lisansTipi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].lisansTipi
        : null
    );
    formVars.homepage_384546_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].lisansBitisTarihi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].lisansBitisTarihi
        : null
    );
    stateVars.isComp200514Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp226317Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp744468Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp664151Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HomePage/HomePagePageInit4_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Home_Summary_FTL_Bekleyen =
        result?.data.get_Home_Summary_FTL_Bekleyen;
      formVars.homepage_877346_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Home_Summary_FTL_Bekleyen !== undefined
          ? stateVars.Get_Home_Summary_FTL_Bekleyen?.length > 0
            ? stateVars.Get_Home_Summary_FTL_Bekleyen[0].bekleyen
            : null
          : this.state.Get_Home_Summary_FTL_Bekleyen?.length > 0
          ? this.state.Get_Home_Summary_FTL_Bekleyen[0].bekleyen
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit5_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HomePage/HomePagePageInit5_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Home_Summary_LTL_Bekleyen =
        result?.data.get_Home_Summary_LTL_Bekleyen;
      formVars.homepage_739463_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Home_Summary_LTL_Bekleyen !== undefined
          ? stateVars.Get_Home_Summary_LTL_Bekleyen?.length > 0
            ? stateVars.Get_Home_Summary_LTL_Bekleyen[0].bekleyen
            : null
          : this.state.Get_Home_Summary_LTL_Bekleyen?.length > 0
          ? this.state.Get_Home_Summary_LTL_Bekleyen[0].bekleyen
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit6_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      TeslimYili_0: ReactSystemFunctions.convertToTypeByName(2025, "number"),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HomePage/HomePagePageInit6_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Home_Summary_FTL_Tamamlanan =
        result?.data.get_Home_Summary_FTL_Tamamlanan;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit7_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      TeslimatYili_0: ReactSystemFunctions.convertToTypeByName(2025, "number"),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HomePage/HomePagePageInit7_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Home_Summary_LTL_Tamamlanan =
        result?.data.get_Home_Summary_LTL_Tamamlanan;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit8_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Date !== undefined
            ? stateVars.Get_Date?.length > 0
              ? stateVars.Get_Date[0].gunSqlFilter
              : null
            : this.state.Get_Date?.length > 0
            ? this.state.Get_Date[0].gunSqlFilter
            : null
        ),
        "Date"
      ),
      _Username_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].smsUserName
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].smsUserName
            : null
        ),
        "string"
      ),
      _Password_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].smsPassword
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].smsPassword
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePagePageInit8_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_YukVeren_DashboardOzet =
      result?.data.rprv2_YukVeren_DashboardOzet;
    formVars.homepage_753595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam
        : null
    );
    formVars.homepage_680930_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen
        : null
    );
    formVars.homepage_50746_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor
        : null
    );
    formVars.homepage_197662_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen
        : null
    );
    formVars.homepage_147739_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis
        : null
    );
    formVars.homepage_895122_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam_Aylik
        : null
    );
    formVars.homepage_521943_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Aylik
        : null
    );
    formVars.homepage_968302_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Aylik
        : null
    );
    formVars.homepage_605454_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Aylik
        : null
    );
    formVars.homepage_291802_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Aylik
        : null
    );
    formVars.homepage_309546_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam_Yillik
        : null
    );
    formVars.homepage_161835_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Yillik
        : null
    );
    formVars.homepage_361807_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Yillik
        : null
    );
    formVars.homepage_488327_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Yillik
        : null
    );
    formVars.homepage_952983_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Yillik
        : null
    );
    stateVars.Sms_Get_Credits = result?.data.sms_Get_Credits;
    formVars.homepage_738977_value = ReactSystemFunctions.toString(
      this,
      stateVars.Sms_Get_Credits
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit9_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "homepage_807538_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("2", "string"),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "homepage_201614_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.Get_Date !== undefined
          ? stateVars.Get_Date?.length > 0
            ? stateVars.Get_Date[0].gunSqlFilter
            : null
          : this.state.Get_Date?.length > 0
          ? this.state.Get_Date[0].gunSqlFilter
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "homepage_542354_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.Get_Date !== undefined
          ? stateVars.Get_Date?.length > 0
            ? stateVars.Get_Date[0].yil
            : null
          : this.state.Get_Date?.length > 0
          ? this.state.Get_Date[0].yil
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "homepage_739949_value",
        "string"
      ),
      moment().format("YYYY-MM-DDTHH:mm:ss"),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit10_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagePageInit10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      UserRole_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
      BagliFirmaId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      RaporTuru_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      RaporTuru_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePagePageInit10_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    formVars.homepage_298373_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Helpers_UserInfoByUserName !== undefined
        ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
          ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaAdi
          : null
        : this.state.Get_Helpers_UserInfoByUserName?.length > 0
        ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaAdi
        : null
    );
    stateVars.Get_Tanim_TedarikciListe = result?.data.get_Tanim_TedarikciListe;

    formVars.homepage_419747_options = stateVars.Get_Tanim_TedarikciListe;
    stateVars.Rprv2_TedarikciPerformans_Dashboard =
      result?.data.rprv2_TedarikciPerformans_Dashboard;

    stateVars.Rprv2_YuklemePerformans_Dashboard =
      result?.data.rprv2_YuklemePerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepage_141793_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaAdi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaAdi
        : null
    );

    formVars.homepage_291688_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].lisansTipi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].lisansTipi
        : null
    );

    formVars.homepage_384546_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].lisansBitisTarihi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].lisansBitisTarihi
        : null
    );

    formVars.homepage_738977_value = ReactSystemFunctions.toString(
      this,
      this.state.Sms_Get_Credits
    );

    formVars.homepage_298373_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Helpers_UserInfoByUserName !== undefined
        ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
          ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaAdi
          : null
        : this.state.Get_Helpers_UserInfoByUserName?.length > 0
        ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaAdi
        : null
    );

    stateVars.isComp200514Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit12_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagePageInit12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      formVars.homepage_877346_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Home_Summary_FTL_Bekleyen !== undefined
          ? stateVars.Get_Home_Summary_FTL_Bekleyen?.length > 0
            ? stateVars.Get_Home_Summary_FTL_Bekleyen[0].bekleyen
            : null
          : this.state.Get_Home_Summary_FTL_Bekleyen?.length > 0
          ? this.state.Get_Home_Summary_FTL_Bekleyen[0].bekleyen
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit13_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit13_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagePageInit13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepage_982081_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Date !== undefined
        ? stateVars.Get_Date?.length > 0
          ? stateVars.Get_Date[0].yil
          : null
        : this.state.Get_Date?.length > 0
        ? this.state.Get_Date[0].yil
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit14_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagePageInit14_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit15_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit15_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagePageInit15_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      stateVars.dataSource_245416 =
        stateVars.Get_Home_Summary_FTL_Tamamlanan ??
        this.state.Get_Home_Summary_FTL_Tamamlanan;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit16_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit16_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagePageInit16_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      formVars.homepage_739463_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Home_Summary_LTL_Bekleyen !== undefined
          ? stateVars.Get_Home_Summary_LTL_Bekleyen?.length > 0
            ? stateVars.Get_Home_Summary_LTL_Bekleyen[0].bekleyen
            : null
          : this.state.Get_Home_Summary_LTL_Bekleyen?.length > 0
          ? this.state.Get_Home_Summary_LTL_Bekleyen[0].bekleyen
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit17_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit17_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagePageInit17_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepage_271474_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Date !== undefined
        ? stateVars.Get_Date?.length > 0
          ? stateVars.Get_Date[0].yil
          : null
        : this.state.Get_Date?.length > 0
        ? this.state.Get_Date[0].yil
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit18_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagePageInit18_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit19_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit19_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagePageInit19_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      stateVars.dataSource_105487 =
        stateVars.Get_Home_Summary_LTL_Tamamlanan ??
        this.state.Get_Home_Summary_LTL_Tamamlanan;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit20_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagePageInit20_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagePageInit20_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp226317Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp996995Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp426910Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp535107Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp420656Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_419747 =
      stateVars.Get_Tanim_TedarikciListe ?? this.state.Get_Tanim_TedarikciListe;
    stateVars.dataSource_419747 =
      stateVars.Get_Tanim_TedarikciListe ?? this.state.Get_Tanim_TedarikciListe;

    stateVars.dataSource_193959 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_458364 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_13893 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    stateVars.dataSource_696194 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;
    stateVars.isComp744468Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp664151Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.homepage_753595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam
        : null
    );

    formVars.homepage_680930_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen
        : null
    );

    formVars.homepage_50746_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor
        : null
    );

    formVars.homepage_197662_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen
        : null
    );

    formVars.homepage_147739_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis
        : null
    );

    formVars.homepage_895122_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam_Aylik
        : null
    );

    formVars.homepage_521943_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Aylik
        : null
    );

    formVars.homepage_968302_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Aylik
        : null
    );

    formVars.homepage_605454_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Aylik
        : null
    );

    formVars.homepage_291802_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Aylik
        : null
    );

    formVars.homepage_309546_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam_Yillik
        : null
    );

    formVars.homepage_161835_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Yillik
        : null
    );

    formVars.homepage_361807_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Yillik
        : null
    );

    formVars.homepage_488327_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Yillik
        : null
    );

    formVars.homepage_952983_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Yillik
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePageComponent_542684_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.HomePageComponent_542684_onClick1_,
        "HomePage",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "179034",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePageComponent_542684_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePageComponent_542684_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.HomePageComponent_542684_onClick2_,
        "HomePage",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "642910",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePageComponent_542684_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePageComponent_542684_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "HomePage",
        "LeftMenuBos",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "973664",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  HomePageComponent_807538_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RaporTuru_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      RaporTuru_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePageComponent_807538_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_TedarikciPerformans_Dashboard =
      result?.data.rprv2_TedarikciPerformans_Dashboard;

    stateVars.Rprv2_YuklemePerformans_Dashboard =
      result?.data.rprv2_YuklemePerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageComponent_807538_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePageComponent_807538_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp996995Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp426910Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp535107Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp420656Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_193959 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_458364 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_13893 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    stateVars.dataSource_696194 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_542354_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RaporTuru_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      RaporTuru_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePageComponent_542354_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_TedarikciPerformans_Dashboard =
      result?.data.rprv2_TedarikciPerformans_Dashboard;

    stateVars.Rprv2_YuklemePerformans_Dashboard =
      result?.data.rprv2_YuklemePerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageComponent_542354_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePageComponent_542354_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_193959 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_458364 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_13893 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    stateVars.dataSource_696194 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_739949_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RaporTuru_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      RaporTuru_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePageComponent_739949_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_TedarikciPerformans_Dashboard =
      result?.data.rprv2_TedarikciPerformans_Dashboard;

    stateVars.Rprv2_YuklemePerformans_Dashboard =
      result?.data.rprv2_YuklemePerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageComponent_739949_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePageComponent_739949_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_193959 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_458364 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_13893 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    stateVars.dataSource_696194 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_201614_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RaporTuru_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      RaporTuru_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePageComponent_201614_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_TedarikciPerformans_Dashboard =
      result?.data.rprv2_TedarikciPerformans_Dashboard;

    stateVars.Rprv2_YuklemePerformans_Dashboard =
      result?.data.rprv2_YuklemePerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageComponent_201614_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePageComponent_201614_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_193959 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_458364 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_13893 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    stateVars.dataSource_696194 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_419747_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RaporTuru_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      RaporTuru_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_807538_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YilKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_542354_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TedarikciId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_419747_value",
            "value",
            "Get_Tanim_TedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      AyKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.dateGetMonth(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_739949_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Gun_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "homepage_201614_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePageComponent_419747_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_TedarikciPerformans_Dashboard =
      result?.data.rprv2_TedarikciPerformans_Dashboard;

    stateVars.Rprv2_YuklemePerformans_Dashboard =
      result?.data.rprv2_YuklemePerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageComponent_419747_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePageComponent_419747_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_193959 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_458364 =
      stateVars.Rprv2_YuklemePerformans_Dashboard ??
      this.state.Rprv2_YuklemePerformans_Dashboard;

    stateVars.dataSource_13893 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    stateVars.dataSource_696194 =
      stateVars.Rprv2_TedarikciPerformans_Dashboard ??
      this.state.Rprv2_TedarikciPerformans_Dashboard;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 179034, 642910, 973664] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePagePageInit();
    }
    if (diId == 179034) {
      isErrorOccurred = await this.HomePageComponent_542684_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 642910) {
      isErrorOccurred = await this.HomePageComponent_542684_onClick2_();
      if (isErrorOccurred) return true;
    }
  }
}
